import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About"; 
import Brands from "./pages/Brands"; 
import Logistics from "./pages/Logistics"; 
import Sustainability from "./pages/Sustainability"; 
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TradeLogin from "./pages/trade/TradeLogin";
import TradeDashboard from "./pages/trade/TradeDashboard";
import PrintableLeadForm from "./pages/trade/PrintableLeadForm";
import { Toaster } from "@/components/ui/sonner";

// Layout wrapper for public pages to include Navbar/Footer
const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main className="flex-grow">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-[color:var(--bg-page)] text-white selection:bg-[color:var(--brand-primary)] selection:text-white">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/our-story" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/brands" element={<PublicLayout><Brands /></PublicLayout>} />
          {/* <Route path="/infrastructure" element={<PublicLayout><Logistics /></PublicLayout>} /> */}
          <Route path="/responsibility" element={<PublicLayout><Sustainability /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          <Route path="/careers" element={<PublicLayout><Careers /></PublicLayout>} />
          <Route path="/privacy" element={<PublicLayout><Privacy /></PublicLayout>} />
          <Route path="/terms" element={<PublicLayout><Terms /></PublicLayout>} />
          
          {/* Legacy Redirects */}
          <Route path="/catalogues" element={<Navigate to="/brands" replace />} />
          <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
          <Route path="/logistics" element={<PublicLayout><Logistics /></PublicLayout>} />
          <Route path="/sustainability" element={<PublicLayout><Sustainability /></PublicLayout>} />

          {/* Trade Portal (No Navbar/Footer) */}
          <Route path="/trade/login" element={<TradeLogin />} />
          <Route path="/trade/print-lead-form" element={<PrintableLeadForm />} />
          <Route path="/trade/dashboard" element={<TradeDashboard />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
